import React, { ReactElement } from 'react';
import { Box, Typography } from '@mui/material';
import {
  COLORS,
  FONT,
  CampusResource,
  DEFAULT_CAMPUS_RESOURCES,
} from '../shared';
import { ResourceRow } from './ResourceRow';

export interface CampusResourcesWidgetProps {
  resources?: CampusResource[];
  onSelect?: (resource: CampusResource) => void;
}

export const CampusResourcesWidget = ({
  resources = DEFAULT_CAMPUS_RESOURCES,
  onSelect,
}: CampusResourcesWidgetProps): ReactElement => (
  <Box width="100%" display="flex" flexDirection="column" gap="12px">
    <Typography
      component="h2"
      sx={{
        fontFamily: FONT,
        fontWeight: 600,
        fontSize: '18px',
        color: COLORS.bodyDark,
        m: 0,
      }}
    >
      Campus resources
    </Typography>
    <Box>
      {resources.map((resource, index) => (
        <ResourceRow
          key={resource.id}
          icon={resource.icon}
          label={resource.label}
          isLast={index === resources.length - 1}
          onClick={() => {
            if (onSelect) onSelect(resource);
            else if (resource.href && typeof window !== 'undefined') {
              window.open(resource.href, '_blank', 'noopener,noreferrer');
            }
          }}
        />
      ))}
    </Box>
  </Box>
);
